// src/pages/trinity/platform.jsx
import EtHeader from "@/components/navigation/EtHeader";
import EtFooter from "@/components/navigation/EtFooter";
import EtHowItWorks from "@/components/sections/EtHowItWorks";
import EtTestimonials from "@/components/sections/EtTestimonials";
import EtCallToAction from "@/components/sections/EtCallToAction";
import EtContact from "@/components/sections/EtContact";


import EtTrinityPlatformHero from "@/components/sections/EtTrinityPlatformHero";
import EtTrinityOverview from "@/components/sections/EtTrinityOverview";
import EtTrinityFoundations from "@/components/sections/EtTrinityFoundations";

// Optionally reuse EtTrinityAdvantage if relevant
import EtTrinityAdvantage from "@/components/sections/EtTrinityAdvantage";
import EtTrinityProblems from "@/components/sections/EtTrinityProblems";
import EtTrinityExperienceCTA from "@/components/sections/EtTrinityExperienceCTA";

// 20 Nov 2025
import {useState, useEffect} from "react"

export default function EtTrinityPlatform() {

 // First Created - 03 Oct 2025
 // Author - Atul Pandey
 // Updated - 20 Nov 2025 - scroll control

 // 1 - Scroll to top on reload - 20 Nov 2025
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const hash = window.location.hash;
      if (hash) {
        const el = document.querySelector(hash);
        if (el) {
          setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth" });
          }, 100); 
        }
      }
    }
  }, []);

  return (
    <div className="font-poppins bg-black text-white">
      <EtHeader variant="platform" />
      <EtTrinityPlatformHero />
      <EtTrinityOverview />
      {/* <EtTrinityFoundations /> */}
      <EtTrinityProblems />
      <EtHowItWorks ctaVariant="experience"/>
      {/* <EtTestimonials /> */}
      {/* <EtCallToAction /> */}
      {/* <EtContact /> */}
      <EtTrinityExperienceCTA />
      <EtFooter variant="trinity" />
    </div>
  );
}